import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SharedToiletIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SharedToiletIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.2878 11.1378H7.21975V7.30239H8.17394C8.45687 7.30239 8.68613 7.0723 8.68613 6.78845C8.68613 6.5046 8.45687 6.27451 8.17394 6.27451H6.70757C6.42464 6.27451 6.19538 6.50459 6.19538 6.78845V7.36643H3.89159C3.60866 7.36643 3.3794 7.59651 3.3794 7.88037V14.9555C3.3787 15.0918 3.43305 15.2225 3.52922 15.3189C3.62539 15.4154 3.75569 15.4694 3.89159 15.4694H5.57797V21.7882C5.57797 22.072 5.80723 22.3021 6.09016 22.3021H15.8524C16.1339 22.3021 16.3625 22.0745 16.3646 21.7923L16.3882 18.8232H17.0426C19.1143 18.8232 20.8007 17.1319 20.8007 15.0532V11.6518C20.8007 11.3679 20.5707 11.1378 20.2878 11.1378ZM6.19538 8.3943V11.1378H4.40377V8.3943H6.19538ZM19.7756 15.0531C19.7756 16.5652 18.5499 17.7952 17.0426 17.7952H9.69357C9.41065 17.7952 9.18138 18.0253 9.18138 18.3092C9.18138 18.593 9.41065 18.8231 9.69357 18.8231H15.3639L15.3444 21.2742H6.60233V14.9555C6.60233 14.6717 6.37306 14.4416 6.09014 14.4416H4.40376V12.1657H19.7756L19.7756 15.0531Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7331 8.52891L19.2992 7.39009C18.9739 6.57665 18.1604 6.03435 17.2927 6.03435H16.9131C16.0455 6.03435 15.232 6.57665 14.9066 7.39009L14.6355 8.04084C14.2017 7.82392 13.7678 7.66123 13.2798 7.66123H12.2494C11.1106 7.66123 10.1344 8.31198 9.75483 9.34235L8.99562 11.2404C8.88716 11.5115 8.99562 11.8369 9.321 11.9454C9.64638 12.0538 9.91752 11.9454 10.026 11.62L10.7852 9.72195C11.0021 9.12543 11.5986 8.74582 12.2494 8.74582H13.2255C13.8763 8.74582 14.4728 9.12543 14.744 9.77618L15.5032 11.6742C15.6116 11.8911 15.7743 11.9996 15.9912 11.9996C16.0455 11.9996 16.0997 11.9996 16.2082 11.9454C16.4793 11.8369 16.642 11.5115 16.5335 11.2404L15.7743 9.34235C15.7201 9.17966 15.6116 8.96274 15.5032 8.80005L15.937 7.76969C16.0997 7.33585 16.4793 7.06471 16.9674 7.06471H17.347C17.7808 7.06471 18.2147 7.33586 18.3773 7.76969L18.8112 8.90851C18.9196 9.12543 19.0823 9.23389 19.2993 9.23389C19.3535 9.23389 19.4077 9.23389 19.5162 9.17966C19.7331 9.12543 19.8415 8.80005 19.7331 8.52891Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.7375 7.11894C13.9305 7.11894 14.9066 6.14281 14.9066 4.94976C14.9066 3.75671 13.9305 2.78058 12.7375 2.78058C11.5444 2.78058 10.5683 3.75671 10.5683 4.94976C10.5683 6.14281 11.5444 7.11894 12.7375 7.11894ZM12.7375 3.86517C13.334 3.86517 13.8221 4.35324 13.8221 4.94976C13.8221 5.54628 13.334 6.03435 12.7375 6.03435C12.1409 6.03435 11.6529 5.54628 11.6529 4.94976C11.6529 4.35324 12.1409 3.86517 12.7375 3.86517Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0758 5.49206C17.9977 5.49206 18.7027 4.78708 18.7027 3.86517C18.7027 2.94326 17.9977 2.23828 17.0758 2.23828C16.1539 2.23828 15.4489 2.94326 15.4489 3.86517C15.4489 4.78708 16.1539 5.49206 17.0758 5.49206ZM17.0758 3.32288C17.4012 3.32288 17.6181 3.5398 17.6181 3.86518C17.6181 4.19056 17.4012 4.40748 17.0758 4.40748C16.7505 4.40748 16.5335 4.19056 16.5335 3.86518C16.5335 3.5398 16.7505 3.32288 17.0758 3.32288Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SharedToiletIcon;
